import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Image, Flex} from 'antd';
import { postApi } from "../services/api.jsx";
import { Link } from 'react-router-dom';
import LoginLogo from "../assets/img/spinner1.png";


const { Title } = Typography;

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [showResetForm, setShowResetForm] = useState(false);
  const [email, setEmail] = useState('');
  const [passwordSent, setPasswordSent] = useState(false);

  const handleEmailSubmit = async (values) => {
    setLoading(true);
    try {
      await postApi(`/auth/forgotPassword`, values, 'application/x-www-form-urlencoded');
      setPasswordSent(true);
      message.success('Password reset code has been sent to your email address');
      setEmail(values.email);
      setShowResetForm(true);
    } catch (error) {
      message.error(error.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };
  
  const handleResetPassword = async (values) => {
    setLoading(true);
    try {
      await postApi(`/auth/confirmPassword`, {
        email: values.email,
        confirmationCode: values.confirmationCode,
        password: values.password
      });
      message.success('Your password has been changed successfully.');
      await new Promise(resolve => setTimeout(resolve, 3000));
    } catch (error) {
      message.error(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      background: '#f0f2f5'
    }}>
      <Card style={{ width: 500, padding: '24px' }}>
        {!showResetForm ? (
          <>
           <Flex justify="center">
             <Image preview={false} src={LoginLogo}  />
           </Flex>
            <Title level={3} style={{ textAlign: 'center', color: '#0050b5', marginBottom: 32 }}>
              Password Reset
              <div style={{ fontSize: '14px', color: '#333', marginTop: '8px' }}>
                Enter your email to receive a reset code
              </div>
            </Title>

            <Form
              name="email-form"
              onFinish={handleEmailSubmit}
              layout="vertical"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
              >
                <Input 
                  size="large"
                  placeholder="Email Address"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  loading={loading}
                  style={{ backgroundColor: "#0050b5", color: "#fff", padding: "20px" }}
                  htmlType="submit"
                  block
                  shape="round"
                >
                  Send Reset Code
                </Button>
              </Form.Item>

              <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <Link to="/login" style={{ color: '#0050b5' }}>
                  Back to Login
                </Link>
              </div>
            </Form>
          </>
        ) : (
          <>
            {passwordSent && (
              <div style={{ 
                textAlign: 'center', 
                marginBottom: '20px', 
                padding: '10px',
                background: '#f6ffed',
                border: '1px solid #b7eb8f',
                borderRadius: '4px'
              }}>
                <strong>Password Reset Code Sent</strong>
                <div style={{ fontSize: '14px', marginTop: '10px', textAlign: 'left' }}>
                  If you haven't received the password reset email:
                  <ul style={{ marginTop: '5px', paddingLeft: '20px' }}>
                    <li>It may take up to 10 minutes for the password reset email to arrive</li>
                    <li>Check your spam and other email folders</li>
                    <li>Verify that you entered the correct email address</li>
                  </ul>
                </div>
              </div>
            )}
            <Title level={3} style={{ textAlign: 'center', color: '#0050b5', marginBottom: 32 }}>
              Reset Password
      
            </Title>
            
            <Form
              name="reset-password"
              onFinish={handleResetPassword}
              layout="vertical"
              initialValues={{ email }}
            >
              <Form.Item label="Email"
                name="email"
                initialValue={email}
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
              >
                <Input 
                  size="large"
                  placeholder="Email Address"
                
                />
              </Form.Item>

              <Form.Item label="Reset Code"
                name="confirmationCode"
                rules={[
                  { required: true, message: 'Please input the reset code!' }
                ]}
              >
                <Input 
                  size="large"
                  placeholder="Reset Code"
                />
              </Form.Item>

              <Form.Item label="New Password"
                name="password"
                rules={[
                  { required: true, message: 'Please input your new password!' },
                  { min: 6, message: 'Password must be at least 6 characters!' }
                ]}
              >
                <Input.Password
                  size="large" 
                  placeholder="New Password"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  loading={loading}
                  style={{ backgroundColor: "#0050b5", color: "#fff" }}
                  htmlType="submit"
                  block
                  shape="round"
                >
                  Set New Password
                </Button>
              </Form.Item>

              <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <Link to="/login" style={{ color: '#0050b5', textDecoration: 'underline' }}>
                  Back to Login
                </Link>
              </div>
            </Form>
          </>
        )}
      </Card>
    </div>
  );
};

export default ForgotPassword;